import { UserInfo } from './user-info.modal';

export class ShareInfoUsersListModal {
  shareStatus: String = 'Shared';
  userList: UserInfo[] = [];
}
